import api from "../../api/index.js";

const state = {};

const getters = {};

const actions = {
  GetFrienMemberTeamList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/FrienMemberTeam/FirenList",
        payload,
        (res) => {
          resolve(res.Result);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  GetFrienMemberTeamSList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/FrienMemberTeam/SList",
        payload,
        (res) => {
          resolve(res.Result);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  FrienMemberTeamPost({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post(
        "/FrienMemberTeam/Post",
        payload,
        (res) => {
          resolve(res.Result);
        },
        (err) => {
          reject(err);
        }
      );
    });
  },
  FrienMemberTeamPostState({ commit }, payload){
    return new Promise((resolve, reject) => {
      api.post(
        "/FrienMemberTeam/PostState",
        payload,
        (res) => {
          resolve(res.Result);
        },
        (err) => {
          reject(err);
        }
      );
    });
  }

};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
